import React, { useState } from 'react';
import { AutoComplete, Button, Table } from 'antd';
import './AddActionDrawer.css';
import { RxCross2 } from 'react-icons/rx';
import { MdAdd } from 'react-icons/md';

const sideCross = '/assets/ModalClose.svg';
const SearchIcon = '/assets/SearchIcon.svg';

const columns = [
    {
        title: 'Quickaction Name',
        dataIndex: 'name',
        sorter: (a, b) => a.age - b.age,
    },
    {
        title: 'Folder Name',
        dataIndex: 'address',
    },
];
const data = [];
for (let i = 0; i < 5; i++) {
    data.push({
        key: i,
        name: `Edward King ${i}`,
        address: `London, Park Lane no. ${i}`,
    });
}
const AddActionDrawer = ({ StandardOverlay }) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const [addedMembers, setAddedMember] = useState([]);
    const mydata = ['Outboound Email'];

    const handleAddedMember = (index, item) => {
        if (selectedValue && !addedMembers.includes(selectedValue)) {
            const updatedMembers = [...addedMembers];
            updatedMembers.splice(index, 0, item);
            setAddedMember(updatedMembers);
            setSelectedValue(null);
        }
    };

    const options = mydata.map((item, index) => ({
        value: item,
        label: (
            <div className='member-added-dropdown' key={index}>
                <div className='member-added-dropdown-data'>
                    {/* <img src={profile} alt="" /> */}
                    <div>
                        <p>{item}</p>
                        <p>
                            Toatal Qa : <b>50</b>
                        </p>
                    </div>
                </div>
                <div onClick={() => handleAddedMember(index, item)}>
                    <MdAdd />
                    <p>Select</p>
                </div>
            </div>
        ),
    }));

    return (
        <div>
            <div>
                <div className='drawer-cross-icon'>
                    <h1>Add QuickAction</h1>
                    <img
                        onClick={StandardOverlay}
                        src={sideCross}
                        alt=''
                        className='cross-drawer'
                    />
                </div>
                <p className='drawer-sense'>
                    Move QuickActions into Sales workspace folder
                </p>

                <div className='drawer-add-action-table'>
                    <Table
                        columns={columns}
                        dataSource={data}
                        bordered
                        size='middle'
                        pagination={{
                            pageSize: 6,
                        }}
                        className='mytable'
                    />
                </div>

                <div className='relative search-container autocomplete-div'>
                    <AutoComplete
                        style={{ width: '100%' }}
                        options={options}
                        placeholder='Search quick action... '
                        value={selectedValue}
                        onChange={(value) => setSelectedValue(value)}
                        filterOption={(inputValue, option) =>
                            option?.value
                                .toString()
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                        }
                    />
                    <img src={SearchIcon} alt='' className='search-icon top-icon' />
                    {selectedValue && (
                        <RxCross2
                            className='cross-member'
                            onClick={() => setSelectedValue(null)}
                        />
                    )}

                    <div className='Add-action-drawer-btn'>
                        <Button className='main-api'>Add</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddActionDrawer;
